import flatpickr from 'flatpickr';
import { French } from "flatpickr/dist/l10n/fr.js"

$(function(){
    flatpickr.localize(flatpickr.l10ns.fr);
    flatpickr($(".flatpickr"), {
        allowInput: true,
        disableMobile: true,
        dateFormat: 'd/m/Y',
        locale: French
    });
});